import React, { useState, Component } from "react";
import {
  StyleSheet,
  Keyboard,
  TextInput,
  TouchableOpacity,
} from "react-native";

import { Text, View, Input, Button } from "native-base";

import Modal from "modal-enhanced-react-native-web";

import { MyCart, Constant } from "./Data.js";

export class TipModal extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      item: props.item,
      commentBarText: "",
    };
  }

  onTipSelected = (percentage) => {
    this.props.onTipSelected(percentage);
    this.closeModal();
  };

  closeModal = () => {
    this.setState({ visible: false });
    Keyboard.dismiss();
  };

  openModal = () => {
    this.setState({ visible: true });
  };

  render() {
    return (
      <Modal
        isVisible={this.state.visible}
        visible={this.state.visible}
        backdropColor="black"
        backdropOpacity={0.8}
        animationOut="slideOutDown"
        animationIn="bounceIn"
        avoidKeyboard={true}
        onBackdropPress={() => this.closeModal()}
        onBackButtonPress={() => this.closeModal()}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View style={{ flexDirection: "column", flex: 1 }}>
              <Text
                style={{
                  fontSize: 20,
                  fontFamily: Constant.font,
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                Add a Tip
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  height: 60,
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.boxStyle}
                  onPress={() => this.onTipSelected(0.2)}
                >
                  <Text style={styles.textStyle}>20%</Text>
                </TouchableOpacity>
                <View style={{ width: 20 }} />
                <TouchableOpacity
                  style={styles.boxStyle}
                  onPress={() => this.onTipSelected(0.25)}
                >
                  <Text style={styles.textStyle}>25%</Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  height: 60,
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                <TouchableOpacity
                  style={styles.boxStyle}
                  onPress={() => this.onTipSelected(0.3)}
                >
                  <Text style={styles.textStyle}>30%</Text>
                </TouchableOpacity>
                <View style={{ width: 20 }} />
                <TouchableOpacity
                  style={styles.boxStyle}
                  onPress={() => this.onTipSelected(0.4)}
                >
                  <Text style={styles.textStyle}>40%</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  centeredView: {
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 32,

    width: "90%",
  },
  textStyle: {
    fontFamily: Constant.font,
    fontSize: 16,
  },
  boxStyle: {
    backgroundColor: Constant.gray,
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
  },
});

function idGenerator() {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}
